import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyNews } from "../models/company-news";
import { OrderFilter } from "../models/order";
import { UrlConstants } from "../models/urlConstants";
import { FileDetails, SearchObj, Sector } from "../models/report";
import { IPO, IPODetails, IpoDocuments } from "../models/IPO";
import { Observable } from "rxjs";
import { SettingsDto, SettingsEnum } from "../models/settings-enum-dto";
import { TranslateService } from "@ngx-translate/core";
@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(private http: HttpClient) {}

  //MARKET APIS
  fetchExpectedVwap(symbolCode: any) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetExpectedVwap?symbolCode=` +
      symbolCode);
  }
  fetchSymbolTradesByTime(symbolCode: any, skip: any, take: any, fromTime: any, toTime: any) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetSymbolTradesByTime?SymbolCode=${symbolCode}&Skip=${skip}&Take=${take}&FromTime=${fromTime}&ToTime=${toTime}`);
  }


  fetchTodayMarketWatch() {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetTodayMarketWatch`
    );
  }

  fetchNotMarketSymbols() {
    return this.http.get(`${UrlConstants.feedUrl}/api/Feed/SearchMarketWatch`);
  }

  fetchAllMarketWatch() {
    return this.http.get(`${UrlConstants.feedUrl}/api/Feed/GetAllMarketWatch`);
  }

  fetchCompany(symbol) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetMarketWatchForSymbol?SYMBOL_CODE=` +
        symbol
    );
  }

  fetchEGX(egx) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetEGXMarketWatch?egxName=` + egx
    );
  }
  fetchDepartments() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetDepartments`
    );
  }

  fetchEgxMarket(x) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetEGXMarketWatchByMarket?marketCode=` +
        x
    );
  }

  fetchCompanyNews(symbolCode) {
    return this.http.get<CompanyNews[]>(
      `${UrlConstants.feedUrl}/api/Feed/getTopFormattedNews?count=10&SYMBOL_CODE=` +
        symbolCode
    );
  }

  fetchMarketNews() {
    return this.http.get<CompanyNews[]>(
      `${UrlConstants.feedUrl}/api/Feed/getTodayFormattedNews?type=1`
    );
  }

  fetchCompanyTrades(symbolCode) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetTodaySymbolTrades?SYMBOL_CODE=` +
        symbolCode
    );
  }

  fetchCompanyTradesByTime(symbolCode) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetSymbolTrades?SYMBOL_CODE=` +
        symbolCode +
        "&count=20"
    );
  }

  fetchMarketTrades() {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetTodayTrades?count=10`
    );
  }

  fetchAllMarketDepth() {
    return this.http.get(`${UrlConstants.feedUrl}/api/Feed/GetTodayTrades`);
  }

  fetchPurchasePower(relCode) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Client/GetClientPurchasePower?relationCode=` +
        relCode
    );
  }

  fetchOrders(relCode, filter) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Orders/GetMyOrders?relationCode=` +
        relCode +
        "&fixStatusGroup=" +
        filter
    );
  }
  fetchfilteredOrders(request: OrderFilter) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Orders/GetMyOrdersByRange`,
      request
    );
  }
  fetchMarginCalculator(request: any) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Client/MarginCalculator`,
      request
    );
  }
  fetchOrderHistory(orderNumber) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Orders/GetOrder?OrderNumber=` +
        orderNumber
    );
  }
  fetchfilteredTransactions(request: OrderFilter) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Orders/getOrderTransactions`,
      request
    );
  }
  fetchWidgetfilteredTransactions(request: OrderFilter) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Orders/getOrderTransactionsWidget`,
      request
    );
  }
  fetchTPlusZero(request) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/TPlusZeroRequest`,
      request
    );
  }
  fetchBOSymbols() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Orders/GetBOSymbols`
    );
  }
  fetchBOAllSymbols() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetBOSymbols`
    );
  }
  fetchAllCustd() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetCustodianList`
    );
  }
  fetchOrder(OrderNumber) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetOrder` + OrderNumber
    );
  }
  fetchOrderFilters() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetOrderFilters`
    );
  }

  cancelOrder(orderId) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Orders/CancelOrder?OrderNumber=` +
        orderId,
      {}
    );
  }

  fetchDepthByOrder(symbolCode) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetMarketDepth?SYMBOL_CODE=` +
        symbolCode
    );
  }

  fetchDepthByPrice(symbolCode, count) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetMarketDepthPerPrice?SYMBOL_CODE=` +
        symbolCode +
        `&count=` +
        count
    );
  }

  fetchMarketSummary() {
    return this.http.get(`${UrlConstants.feedUrl}/api/Feed/GetMarketSummary`);
  }

  fetchMarketStatus() {
    return this.http.get<any[]>(
      `${UrlConstants.feedUrl}/api/Feed/GetMarketStatus`
    );
  }

  fetchGDR() {
    return this.http.get<any[]>(
      `${UrlConstants.globalDataApi}/GlobalMarket/GetGDRChanges`
    );
  }

  fetchMiddleEastIndexes() {
    return this.http.get<any[]>(
      `${UrlConstants.globalDataApi}/GlobalMarket/GetMiddleEastIndesxChanges`
    );
  }

  fetchMajorIndexes() {
    return this.http.get<any[]>(
      `${UrlConstants.globalDataApi}/GlobalMarket/GetMajorIndexesChanges`
    );
  }

  fetchMetals() {
    return this.http.get<any[]>(
      `${UrlConstants.globalDataApi}/GlobalMarket/GetMetalAndEnergyChanges`
    );
  }

  fetchExchangeRates() {
    return this.http.get<any[]>(
      `${UrlConstants.globalDataApi}/GlobalMarket/GetExchangeRate`
    );
  }

  fetchInvestorSummary() {
    return this.http.get<any[]>(
      `${UrlConstants.feedUrl}/api/Feed/GetInvestorSummary`
    );
  }

  fetchAllInvestor() {
    return this.http.get<any[]>(
      `${UrlConstants.feedUrl}/api/Feed/GetAllInvestors`
    );
  }

  fetchInvestorTypeIndividual() {
    return this.http.get<any[]>(
      `${UrlConstants.feedUrl}/api/Feed/GetInvestorTypeIndividual`
    );
  }

  fetchInvestorTypes() {
    return this.http.get<any[]>(
      `${UrlConstants.feedUrl}/api/Feed/GetInvestorTypes`
    );
  }

  fetchTop5Best() {
    return this.http.get<any[]>(
      `${UrlConstants.feedUrl}/api/Feed/GetTop5BestMarketWatch`
    );
  }

  fetchTop5Worst() {
    return this.http.get<any[]>(
      `${UrlConstants.feedUrl}/api/Feed/GetTop5WorstMarketWatch`
    );
  }
  changePassword(changePassObj) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Token/ChangePassword`,
      changePassObj
    );
  }
  checkUserNameAvailability(username: string) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Token/checkUserNameAvailability?username=` +
        username
    );
  }
  logOut(user) {
    return this.http.post(`${UrlConstants.backofficeUrl}/api/Token/Logout`, {
      UserName: user,
    });
  }

  fetchAccounts() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Client/GetAccountList`
    );
  }
  fetchClientsCashPosition(relationCode) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Client/GetClientCashPosition?relationCode=` +
        relationCode
    );
  }
  marginCalculator(request: any) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Client/MarginCalculator`,
      request
    );
  }

  fetchInvoiceById(relationCode, id) {
    return this.http.get(
      `${
        UrlConstants.backofficeUrl
      }/api/Invoice/getInvoicePDF?relationCode=${relationCode}&lang=${1}&invoiceId=${id}`
    );
  }

  fetchMySymbols(relationCode) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Client/GetMyPortfolioSymbols?relationCode=${relationCode}`
    );
  }

  fetchSymbolBO(symbolCode) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetBOSymbol?symbolCode=${symbolCode}`
    );
  }

  fetchMarketWatchNames() {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetAllMarketWatchNames`
    );
  }

  fetchBanks() {
    return this.http.get(`${UrlConstants.backofficeUrl}/api/Settings/GetBanks`);
  }

  fetchCurrencies() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetCurrencies`
    );
  }

  fetchActiveCurrencies() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetActiveCurrencies`
    );
  }

  fetchInvestmentAmount(symbol, relCode) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/Orders/getRequiredInvestmentAmount`,
      {
        relationCode: relCode,
        symbolCode: symbol,
      },
      {}
    );
  }

  fetchClientPortfolio(relationCode, date) {
    return this.http.get(
      `${
        UrlConstants.backofficeUrl
      }/api/Client/getClientPortfolioPDF?relationCode=${relationCode}&lang=${1}&wantedDate=${date}`
    );
  }

  GetPageItemsByTypesIDs(typesIDs: number[]) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/LandingPage/GetPageItemsByTypesIDs`,
      typesIDs
    );
  }

  GetCompanySettings() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/LandingPage/GetCompanySettings`
    );
  }

  GetAttachmentsByItemIDs(itemsIDs: number[]) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/LandingPage/GetAttachmentsByItemIDs`,
      itemsIDs
    );
  }

  fetchTechnicalAnalysis(searchObj: SearchObj) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/GetTechnicalAnalysis`,
      searchObj
    );
  }

  fetchTechnicalAnalysisList(searchObj: SearchObj) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/GetTechnicalAnalysisList`,
      searchObj
    );
  }

  
  fetchTechnicalAnalysisFile(pageType: number, fileId: number) {
    return this.http.get<FileDetails>(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/GetTechnicalAnalysisFile?pageType=${pageType}&fileId=${fileId}`
    );
  }

  fetchFundmentalAnalysisList(searchObj: SearchObj) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/GetFundmentalAnalysisList`,
      searchObj
    );
  }

  fetchTechnicalAnalysisSymbols() {
    return this.http.get<any[]>(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/GetTechnicalAnalysisSymbols`
    );
  }

  GetAvailableIposList() {
    return this.http.get<IPO[]>(
      `${UrlConstants.backofficeUrl}/api/Ipo/GetAvailableIposList`
    );
  }

  GetIpoDetails(IpoId) {
    return this.http.get<IPODetails>(
      `${UrlConstants.backofficeUrl}/api/Ipo/GetIpoDetails?IpoId=` + IpoId
    );
  }

  GetIpoDocuments(IpoId) {
    return this.http.get<IpoDocuments>(
      `${UrlConstants.backofficeUrl}/api/Ipo/GetIpoDocuments?IpoId=` + IpoId
    );
  }

  fetchIPOTotalVolume(symbolCode: number) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetIPOTotalVolumeBySymbol?symbolCode=${symbolCode}`
    );
  }

  GetMutualFundList(fundType: number = 0) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OfflineOrders/DisplayActiveFunds`,
      { FundTypeID: fundType }
    );
  }
  GetMutualFundDetails(symbolCode: string) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OfflineOrders/DisplayFundDetails`,
      { symbolCode }
    );
  }

  GetFundPriceHistory(symbolCode: string) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OfflineOrders/DisplayFundPriceHistory`,
      { SymbolCode: symbolCode, DataCount: 30 }
    );
  }

  OpenNewFundAccountRequest(MainCode: number, RelationCode: string) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/NewFundAccountRequest`,
      { MainCode: MainCode, RelationCode: RelationCode }
    );
  }
  submitEmailChangeRequest(request) {
  return this.http.post(
    `${UrlConstants.backofficeUrl}/api/OnlineTrading/ChangeEmailRequest`,
    request
  );
  }
  GetMutualFundTypes() {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OfflineOrders/DisplayFundTypes`,
      {}
    );
  }
  FetchBulkTradesSummary() {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetBulkTradesSummary`
    );
  }
  FetchSymbolBulkTradesDetails(SymbolCode: string) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetSymbolBulkTradesDetails?symbolCode=${SymbolCode}`
    );
  }
  FetchBulkTradesSummaryBySymbolCode(SymbolCode: string) {
    return this.http.get(
      `${UrlConstants.feedUrl}/api/Feed/GetSymbolBulkTradesSummary?symbolCode=${SymbolCode}`
    );
  }

  submitCoupon(request) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/CollectCouponsRequest`,
      request
    );
  }
  submitAction(request) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/PostActionRequest`,
      request
    );
  }
  FetchSymbolMetadata() {
    return this.http.get<any[]>(
      `${UrlConstants.feedUrl}/api/DelayedFeed/getAllMarketWatchNames`
    );
  }
  fetchClientAccounts(relCode) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/OMSClient/GetAccountList?RelationCode=${relCode}`
    );
  }
  
  ChangePhoneRequest(request) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/ChangePhoneRequest`,
      request
    );
  }
  getCustodianByRelationCode(relationCode) {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Client/GetCustodianByRelationCode?relationCode=${relationCode}`
    );
  }
  AddPhoneRequest(request) {
    return this.http.post(
      `${UrlConstants.backofficeUrl}/api/OnlineTrading/AddPhoneRequest`,
      request
    );
  }
  fetchClientStocks(relationCode: string): Observable<any> {
    return this.http.get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientPortfolio?relationCode=${relationCode}`
    );
}
 GetSettingsData(requestEnum: SettingsEnum) {
    return this.http.get<SettingsDto[]>(
      `${UrlConstants.backofficeUrl}/api/Settings/GetSettingsData?requestEnum=` + requestEnum
    );
  }

  GetSectors() {
    return this.http.get<Sector[]>(
      `${UrlConstants.backofficeUrl}/api/Settings/GetSectors`
    );
  }

  //enum to array
  enumToArray(data: any): any {
    var output: any = []
    Object.keys(data)
      .filter(key => isNaN(Number(key)))
      .map(index => {
        let result = data[index];
        output.push({ id: result, name: index })
      });
    return output;
  }
}
